import { useLocation } from "@tanstack/react-router";
import { isPreviewSearchEnabled } from "#/_packages/umbrella/features/previews/utils/request-preview-mode.ts";

export default function useIsPreviewMode() {
	return useLocation({
		select: (location) => isPreviewSearchEnabled((location.search as Record<string, unknown>).preview),
	});
}
